import { render, staticRenderFns } from "./VirtualPackingSlipDetailsContainer.vue?vue&type=template&id=d17e037c&"
import script from "./VirtualPackingSlipDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./VirtualPackingSlipDetailsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports